import { PageTitle } from '../layouts/PageTitle';

const CompanyLegal = () => {
  return (
    <section className="p-3">
      <PageTitle title="特定商取引法に基づく表記" />
      <table className="mb-10 w-full border-collapse border border-gray-300">
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            販売事業者名
          </th>
          <td className="py-2 px-3 border border-gray-300">株式会社ALBONA</td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            所在地
          </th>
          <td className="py-2 px-3 border border-gray-300">
            〒150-0043 東京都渋谷区道玄坂1-20-8 寿パークビル4F
          </td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            事業内容
          </th>
          <td className="py-2 px-3 border border-gray-300">
            広告代理業,SNSマーケティング業,D2C事業
          </td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            販売責任者
          </th>
          <td className="py-2 px-3 border border-gray-300">野下 滉貴</td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            電話番号
          </th>
          <td className="py-2 px-3 border border-gray-300">03-6822-6934</td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            メールアドレス
          </th>
          <td className="py-2 px-3 border border-gray-300">support@raysee.jp</td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            キャンセルに関する特約（法11条4号及び省令8条5号）
          </th>
          <td className="py-2 px-3 border border-gray-300">
            対象占い師の鑑定メニューについて返金を希望する場合は、鑑定実施から7日以内に専用のフォームから申請してください。
          </td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            お問い合わせ
          </th>
          <td className="py-2 px-3 border border-gray-300">
            マイページに記載の公式LINE（自動応答のみ）
            <br />
            support@raysee.jp
          </td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            商品代金以外の付帯費用
          </th>
          <td className="py-2 px-3 border border-gray-300">
            当社ウェブサイトのページの閲覧、コンテンツ購入に必要となるインターネット接続料金、通信料金等は、利用者のご負担となります
          </td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            商品に隠れた瑕疵があった場合の責任範囲
          </th>
          <td className="py-2 px-3 border border-gray-300">
            賠償範囲は直近1か月の利用代金を上限とします
          </td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            ソフトウェアの動作環境
          </th>
          <td className="py-2 px-3 border border-gray-300">Webブラウザー</td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            クーリングオフについて
          </th>
          <td className="py-2 px-3 border border-gray-300">
            特定商取引法に規定されているクーリングオフが適用されるサービスではありません。
          </td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            お支払い方法
          </th>
          <td className="py-2 px-3 border border-gray-300">
            <p>・クレジットカード（VISA, Master, JCB, American Express, Diners）</p>
            <p>・キャリア決済（ソフトバンク/Y!mobileまとめて支払い）</p>
            <p>・AmazonPay</p>
            <p>・銀行振込</p>
            <br />
            <p>*商品によってはお選びいただけない支払い方法があります</p>
          </td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            代金の支払い時期
          </th>
          <td className="py-2 px-3 border border-gray-300">
            <p>クレジットカード：鑑定終了日の24時00分</p>
            <p>銀行振込：鑑定終了日から5日後の17時までにお振込み</p>
          </td>
        </tr>
        <tr className="text-sm leading-6 text-black">
          <th className="py-2 px-3 text-left border border-gray-300 bg-gray-50 font-medium">
            商品の引き渡し時期
          </th>
          <td className="py-2 px-3 border border-gray-300">
            購入手続完了後、直ちに占い師とのトークルームを開設します。
            サブスクプランの場合には、サブスクプランの購入後に個別の占いメニューのお申込みをいただき次第、直ちに占い師とのトークルームを開設します。
            ビデオ通話の時期や占い結果の納品時期は各サービスページで案内しています。
          </td>
        </tr>
      </table>
    </section>
  );
};

export { CompanyLegal };
